import styled from "styled-components";
import Typography from "../../../components/Typography";

const DescriptiveTypography = styled(Typography)`
  margin: 12px 0;
`;

export default DescriptiveTypography;
